import styles from './empty-state.module.css';

import type { ReactNode, JSX } from 'react';

export interface EmptyStateProps {
  readonly title: string;
  readonly description?: ReactNode;
}

export function EmptyState({ title, description }: EmptyStateProps): JSX.Element {
  return (
    <div className={styles['root']} role="status">
      <div className={styles['title']}>{title}</div>
      {description !== undefined ? (
        <div className={styles['description']}>{description}</div>
      ) : null}
    </div>
  );
}
